if (!customElements.get('kd-slideshow')) {
  customElements.define(
    'kd-slideshow',
    class ProductSlideshow extends HTMLElement {
      constructor() {
        super();

        this.images = this.getElementsByClassName('product-image');
        this.navigations = this.getElementsByClassName('navigation-image');

        this.size = this.images.length;
        this.size0 = this.images.length - 1;

        this.modal = this.querySelector('slideshow-modal') || document.querySelector('slideshow-modal');

        this.toShowcase(0);
      }

      toShowcase(index) {
        if (this.selected !== undefined) this.images[this.selected].classList.add('hidden', 'selected');
        this.images[index].classList.remove('hidden', 'selected');

        if (this.selected !== undefined) this.navigations[this.selected]?.parentElement.classList.remove('selected');
        this.navigations[index]?.parentElement.classList.add('selected');
        this.navigations[index]?.parentElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });

        if (this.modal) {
          if (this.modal.children.length === 2) this.modal.lastElementChild.remove();
          this.modal.append(this.images[index].cloneNode(true));
          if (this.modal?.lastElementChild?.onclick) this.modal.lastElementChild.onclick = undefined;
        }

        this.selected = index;
      }

      next() {
        this.toShowcase((this.selected + 1) % this.size);
      }

      previous() {
        this.toShowcase(this.selected === 0 ? this.size0 : this.selected - 1);
      }
    }
  );
}

if (!customElements.get('slideshow-modal')) {
  customElements.define(
    'slideshow-modal',
    class SlideshowModal extends HTMLElement {
      constructor() {
        super();
      }

      open() {
        this.classList.remove('hidden');
        document.firstElementChild.classList.add('overflow-hidden');
      }

      close() {
        this.classList.add('hidden');
        document.firstElementChild.classList.remove('overflow-hidden');
      }
    }
  );
}
